<template>
    <div class="meet-add-container global-center" @click="editDoctor">
        <Top  class="meet-add-top-banner"></Top>
        <div class="global-center meet-add-content">
            <img class="meet-add-icon" :src="require(`@/assets/images/icon/add.png`)" alt="">
            新增专家
        </div>
    </div>
</template>

<script>
import login from './login'
import Top from './top.vue'
export default {
    name: "MeetAdd",
    mixins: [login],
    components:{
        Top
    },
    props: {
        meetInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        addType:{
            type:String,
            default:"share",
        }
    },
    methods: {
        async editDoctor() {

            try {
                await this.login()
            } catch (err) {
                console.log(err)
                return;
            }
            this.$router.push({
                path: "/doctor",
                query: {
                    link_id: this.findLinkId(),
                    meet_id: this.$route.query.id,
                    phase:3,
                    come_from: 1 //1= 日程信息，2=签署协议信息
                }
            })
        },
        findLinkId() {
            if(this.addType=="share"){
                let data = this.meetInfo.meet_link.find(doctor => doctor.phase == 3)
                return data.link_id
            }
            if(this.addType=="discuss"){
                let data = this.meetInfo.meet_link.find(doctor => doctor.phase == this.meetInfo.project_info.discuss_phase)
                return data.link_id
            }
        },
    },

}
</script>

<style scoped>
.meet-add-container {
    height: 13px;
    font-weight: 500;
    font-size: 14px;
    color: var(--el-color-primary);
    line-height: 20px;
    margin:-13px 13px 13px;
    background: #fff;
    display: flex;
    width:calc(100% - 26px);
    height:auto;
}

.meet-add-icon {
    height: 14px;
    width: auto;
    margin-right: 10px;
}
.meet-add-top-banner{
    flex:4.5px 0 0;
    height:26px;
}
.meet-add-content{
    flex:1 0 0;
    height:26px;
    padding:6px 0;
}
</style>